"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MeterReadingActions = void 0;
exports.isLoading = isLoading;
exports.loadAllMeters = loadAllMeters;
exports.markMeterSaved = markMeterSaved;
exports.setOpenMeter = setOpenMeter;
var _meterReadingApi = require("../../api/meterReadingApi");
var MeterReadingActions = exports.MeterReadingActions = /*#__PURE__*/function (MeterReadingActions) {
  MeterReadingActions["LOAD_ALL_METERS"] = "api/reducer/LOGGEDIN_ALL_METERS";
  MeterReadingActions["LOADING"] = "api/reducer/LOGGEDIN_ALL_METERS_LOADING";
  MeterReadingActions["MARK_METER_SAVED"] = "reduce/LOGGEDIN_MARK_METER_SAVED";
  MeterReadingActions["OPEN_METER"] = "reduce/LOGGEDIN_OPEN_METER";
  MeterReadingActions["SET_API_ERROR"] = "api/reducer/LOGGEDIN_SET_API_ERROR";
  return MeterReadingActions;
}(MeterReadingActions || {});
function isLoading(dispatch, loading) {
  dispatch({
    type: MeterReadingActions.LOADING,
    data: {
      loading: loading
    }
  });
}
function loadAllMeters(dispatch) {
  isLoading(dispatch, true);
  (0, _meterReadingApi.getAllMeters)().then(function (response) {
    dispatch({
      type: MeterReadingActions.LOAD_ALL_METERS,
      data: {
        devices: response.data.content
      }
    });
    isLoading(dispatch, false);
  }).catch(function (error) {
    dispatch({
      type: MeterReadingActions.SET_API_ERROR,
      data: {
        error: error
      },
      apiError: true,
      loading: false
    });
  });
}
function markMeterSaved(dispatch, serialNumber) {
  return dispatch({
    type: MeterReadingActions.MARK_METER_SAVED,
    serialNumber: serialNumber
  });
}
function setOpenMeter(dispatch, serialNumber) {
  return dispatch({
    type: MeterReadingActions.OPEN_METER,
    serialNumber: serialNumber
  });
}